//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Stap2',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data: () => ({
    maatwerkroute: false,
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    setMaatwerkroute() {
      this.maatwerkroute = true;
      this.$emit('setMaatwerkroute');
    },
    next() {
      this.$emit('next');
    },
    submit(data) {
      this.$emit('submit', data);
    },
  },
};
